<template>
	<div class="course-list">
		<transition-group enter-active-class="animated fadeIn">
			<Course v-for="(course,i) in courses" :key="course.id" v-model="courses[i]" @click="onClick" />
		</transition-group>

		<ListActions v-model="activeCourse" :visible.sync="showActionSheet" entityType="Course" />
	</div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import { CourseEntry } from '@/models';
import ListActions from './ListActions.vue';
import Course from './courses/Course.vue';

@Component({
	components: {
		Course,
		ListActions,
	},
})
export default class CourseList extends Vue {
	private activeCourse: CourseEntry | null = null;
	private showActionSheet: boolean = false;

	public get courses() {
		return this.$store.state.wmct.courses;
	}

	public onClick(course: CourseEntry) {
		this.activeCourse = course;
		this.showActionSheet = true;
	}
}
</script>

<style>
	.course-list {
		margin-bottom: 8vh;
	}
</style>